import { I18N } from "aurelia-i18n";
import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import NewsData from "../../Scripts/AppServiceContract/NewsData";
import { autoinject, Container } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';

@autoinject()
export default class News2EditorVM extends EditorVMBase {
  public i18n: I18N;
  public eventAggregator: EventAggregator;
  changeLocaleSubscribe: any;
  Id: string;
  Description: string;
  EffectiveDate: Date;
  FileInfoList: any;
  Title: string;
  FileInfoId: string;
  FileName: string;
  ShowDate: string;
  DescriptionDisplay: string;
  DatetimeDisplay: string;
  DaysAgo: string;
  MonthsAgo: string;
  WeeksAgo: string;
  Yesterday: string;
  TypeName: string;
  NewsTypeId: string;

  constructor() {
    super();
    this.i18n = Container.instance.get(I18N);
  }

  LoadOriginalSource(originalSource: NewsData) {
    this.Id = originalSource.Id;
    this.NewsTypeId = originalSource.NewsTypeId;
    this.Title = originalSource.Title;
    this.Description = originalSource.Description;
    let dateTime = new Date(originalSource.EffectiveDate);
    this.EffectiveDate = new Date(
      dateTime.getFullYear(),
      dateTime.getMonth(),
      dateTime.getDate()
    );
    this.ShowDate =
      new Intl.DateTimeFormat(this.i18n.tr("Aqs.Common:LangCode"), {
        dateStyle: "full",
      }).format(dateTime);
    this.FileInfoList = originalSource.FileInfoList;
    this.DescriptionDisplay = originalSource.Description.slice(0, 250) + " ...";
    this.TypeName = originalSource.TypeName;
    this.DatetimeDisplay = this.CheckDateDiff();
  }

  SaveOriginalSource(originalSource: NewsData) {
    originalSource.Id = this.Id;
    originalSource.Title = this.Title;
    originalSource.Description = this.Description;
    originalSource.EffectiveDate = this.EffectiveDate;
    originalSource.FileInfoId = this.FileInfoId;
    originalSource.FileName = this.FileName;
    originalSource.FileInfoList = this.FileInfoList;
    originalSource.TypeName = this.TypeName;
  }

  CheckDateDiff() {
    this.DaysAgo = this.i18n.tr('Aqs.News:NewsPage.DaysAgo');
    this.MonthsAgo = this.i18n.tr('Aqs.News:NewsPage.MonthsAgo');
    this.WeeksAgo = this.i18n.tr('Aqs.News:NewsPage.WeeksAgo');
    this.Yesterday = this.i18n.tr('Aqs.News:NewsPage.Yesterday');

    var date = new Date();
    var eventStartTime = new Date();
    var eventEndTime = this.EffectiveDate;
    let timeInMilisec: number = eventStartTime.getTime() - eventEndTime.getTime();
    let daysBetweenDates: number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
    if (daysBetweenDates < 2) {
      this.DatetimeDisplay = this.Yesterday;
    } else {
      if (daysBetweenDates < 7) {
        this.DatetimeDisplay = daysBetweenDates + " " + this.DaysAgo;
      } else {
        if (daysBetweenDates > 30) {
          this.DatetimeDisplay = Math.floor(daysBetweenDates / 30) + " " + this.MonthsAgo;
        } else {
          this.DatetimeDisplay = Math.floor(daysBetweenDates / 7) + " " + this.WeeksAgo;
        }
      }
    }
    return this.DatetimeDisplay;
  }

}
